"use client";

import { Card, Skeleton } from "@mui/material";

export default function Loading() {
  return (
    <>
      <div className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="text-4xl">My Shopping Cart</h1>
      </div>
      <div className="space-y-4">
        <div className="max-w-7xl mx-auto px-4">
          <Card>
            <div className="py-4 items-center border-b border-zinc-200 flex">
              <div className="text-zinc-500 px-4 flex-1">Product</div>
              <div className="text-zinc-500 px-4 w-36">Price</div>
              <div className="text-zinc-500 px-4 w-36">Quantity</div>
              <div className="text-zinc-500 px-4 w-36">Subtotal</div>
              <div className="text-zinc-500 px-4 w-36"></div>
            </div>
            {[1, 2, 3, 4].map((_, i) => (
              <div
                key={i}
                className="flex py-4 items-center border-b border-zinc-200"
              >
                <div className="flex-1 px-4">
                  <div className="inline-flex gap-x-4 items-center">
                    <Skeleton width={128} height={128} variant="rounded" />
                    <Skeleton width={256} variant="rounded" />
                  </div>
                </div>
                <div className="w-36 px-4">
                  <Skeleton width={100} variant="rounded" />
                </div>
                <div className="w-36 px-4">
                  <Skeleton width={60} variant="rounded" />
                </div>
                <div className="w-36 px-4">
                  <Skeleton width={100} variant="rounded" />
                </div>
                <div className="w-36 px-4 flex justify-end">
                  <Skeleton width={36} height={36} variant="circular" />
                </div>
              </div>
            ))}
          </Card>
        </div>
        <div className="bg-white sticky bottom-0 p-4 border-t border-zinc-200 z-10">
          <div className="max-w-7xl mx-auto px-4">
            <div className="flex items-center justify-between gap-4">
              <div>
                <div className="text-2xl flex items-center gap-x-4">
                  Cart Total: <Skeleton width={120} variant="rounded" />
                </div>
                <div className="text-zinc-500 text-sm">
                  Shipping: Calculate at Checkout
                </div>
              </div>
              <div>
                <Skeleton width={160} height={36} variant="rounded" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
